var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Section",
    _vm._b(
      {
        attrs: {
          title: _vm.title,
          shouldShowSearch: _vm.shouldShowSearch,
          toolbarActions: _vm.toolbarActions,
          icon: "construction",
          breadCrumbs: _vm.breadCrumbs,
          isLoading: _vm.isLoading,
        },
        on: {
          onClicked: (val) => _vm.$emit(val),
          onClickBreadcrumb: (val) => _vm.$emit("onClickBreadcrumb", val),
        },
        scopedSlots: _vm._u([
          {
            key: "toolbarExtension",
            fn: function () {
              return [
                _c(
                  "v-layout",
                  {
                    attrs: {
                      row: "",
                      wrap: "",
                      "justify-space-between": "",
                      subheading: "",
                    },
                  },
                  [
                    _c("v-flex", { attrs: { shrink: "" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("v-icon", [_vm._v("info")]),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._entityPropertyValueByName({
                                                  entityList:
                                                    _vm.assetStatusList,
                                                  idKey: "id",
                                                  idValue:
                                                    _vm.assetDetail.statusId,
                                                  propertyKey: "name",
                                                })
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [_vm._v("Equipment Status")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("v-icon", [_vm._v("event")]),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._entityPropertyValueByName({
                                                  entityList:
                                                    _vm.activityTypeList,
                                                  idKey: "id",
                                                  idValue:
                                                    _vm.assetDetail
                                                      .activityTypeIdLast,
                                                  propertyKey: "name",
                                                })
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [_vm._v("Last Activity Performed")]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("v-icon", [_vm._v("style")]),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._entityPropertyValueByName({
                                                  entityList: _vm.modelList,
                                                  idKey: "id",
                                                  idValue:
                                                    _vm.assetDetail.modelId,
                                                  propertyKey: "name",
                                                })
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_vm._v(" "), _c("span", [_vm._v("Model")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("v-icon", [_vm._v("store")]),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._manufacturerByModelId({
                                                  modelList: _vm.modelList,
                                                  manufacturerList:
                                                    _vm.manufacturerList,
                                                  modelId:
                                                    _vm.assetDetail.modelId,
                                                }).name || "[UNKNOWN]"
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_vm._v(" "), _c("span", [_vm._v("Manufacturer")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g({}, on),
                                        [
                                          _c("v-icon", [_vm._v("category")]),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm._categoryByModelId({
                                                  modelList: _vm.modelList,
                                                  categoryList:
                                                    _vm.categoryList,
                                                  modelId:
                                                    _vm.assetDetail.modelId,
                                                }).name || "[UNKNOWN]"
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_vm._v(" "), _c("span", [_vm._v("Category")])]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        attrs: {
                          shrink: "",
                          "text-xs-left": "",
                          "text-sm-right": "",
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._g({}, on),
                                          [
                                            _c("v-icon", [
                                              _vm._v("supervised_user_circle"),
                                            ]),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.clientList,
                                                      idKey: "id",
                                                      idValue:
                                                        _vm.assetDetail
                                                          .clientId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Client")])]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._g({}, on),
                                          [
                                            _c("v-icon", [_vm._v("place")]),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.locationList,
                                                      idKey: "id",
                                                      idValue:
                                                        _vm.assetDetail
                                                          .locationId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Location")])]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.assetDetail.comments
                      ? _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c("v-icon", [_vm._v("comment")]),
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.assetDetail.comments) +
                                "\n      "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "Section",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }